


























































































































































































import Vue from 'vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { confirmationHelper } from '@/mixins/confirmationHelper';
import { FormFieldValidation } from '@/mixins/formValidation';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { CabinetModel, SweepCreateFileSourceDataModel, SweepFileSourceModel, SweepPostProcessAction, SweepPluginModel } from '@/services/GeneratedApi';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SweepFileFolderSourceModal',
  mixins: [confirmationHelper, FormFieldValidation],
  components: {
    MStoreForm,
    MStoreFormInput,
    MStoreFormSelect,
    MStoreFormCheckbox,
    MStoreSpinnerButton,
    LoadingSpinner
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true,
      validator: (value: string) => ['create', 'edit'].includes(value)
    },
    sweepFileFolderSource: {
      type: Object as () => SweepFileSourceModel,
      required: true
    }
  },
  data() {
    return {
      SweepPostProcessAction,
      isVisible: this.visible,
      isSubmitting: false,
      isLoading: false,
      localSweepFileSource: { ...(this as any).sweepFileFolderSource } as SweepFileSourceModel,
      cabinets: [] as CabinetModel[],
      plugins: [] as SweepPluginModel[],
      fileWhitelist: '' as string
    };
  },
  computed: {
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty']),
    modalTitle(this: any): string {
      return this.mode === 'create' ? 'Add Sweep File Folder Source' : `Edit Sweep File Folder Source - ${this.localSweepFileSource?.description || ''}`;
    },
    documentTypeSelectOptions(this: any) {
      const selectedCabinet: CabinetModel | undefined = this.cabinets.find((c: CabinetModel) => c.id === this.localSweepFileSource?.destinationCabinetId);
      return selectedCabinet?.documentTypes || [];
    },
    pluginSelectOptions(this: any): object[] {
      return [{ id: 0, displayName: 'None' }, ...this.plugins];
    },
    postProcessOptions(): object[] {
      return [
        { value: SweepPostProcessAction.Archive, text: 'Move to Archive' },
        { value: SweepPostProcessAction.Delete, text: 'Delete Source Files' }
      ];
    }
  },
  methods: {
    async loadModalData(this: any) {
      this.isLoading = true;
      try {
        const response: SweepCreateFileSourceDataModel = await ApiConfiguration.apiWithErrorPage().sweepFileSourceConfiguration.sweepFileSourceConfigurationCreatefilesourceList();
        this.cabinets = response.cabinets || [];
        this.plugins = response.plugins || [];
        this.fileWhitelist = (response.fileWhitelist || []).join(', ');

        if (this.mode === 'create' && response.defaults) {
          if (response.defaults.defaultArchiveFolderPath) {
            this.localSweepFileSource.archiveFolderPath = response.defaults.defaultArchiveFolderPath;
          }
          if (response.defaults.defaultFailedFolderPath) {
            this.localSweepFileSource.failedFolderPath = response.defaults.defaultFailedFolderPath;
          }
        }
      } catch (error) {
        this.$log(error);
        SnotifyConfiguration.showError('Failed to load modal data');
      } finally {
        this.isLoading = false;
      }
    },
    onCabinetChange(this: any) {
      this.localSweepFileSource.destinationDocumentTypeId = undefined;
    },
    async onSubmitAsync(this: any) {
      const isValid = await this.$refs.form.$refs.ValidationObserver.validate();
      if (!isValid) {
        return;
      }

      this.isSubmitting = true;
      this.setApplicationDirty(false);

      try {
        const payload: SweepFileSourceModel = {
          ...this.localSweepFileSource,
          pluginId: this.localSweepFileSource.pluginId || null
        };

        if (this.mode === 'create') {
          await ApiConfiguration.apiWithErrorPage().sweepFileSourceConfiguration.sweepFileSourceConfigurationCreate(payload);
        } else {
          await ApiConfiguration.apiWithErrorPage().sweepFileSourceConfiguration.sweepFileSourceConfigurationUpdate(payload);
        }
        this.$emit('saved');
        this.isVisible = false;
      } catch (error) {
        this.$log(error);
        SnotifyConfiguration.showError('Failed to save sweep file source');
      } finally {
        this.isSubmitting = false;
      }
    },
    async onCancel(this: any) {
      const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, this.isApplicationDirty);
      if (hasUnsavedChangesToKeep) {
        return;
      }
      this.setApplicationDirty(false);
      this.isVisible = false;
      this.$emit('cancel');
    },
    onDirtyForm(this: any, dirty: boolean) {
      if (this.isApplicationDirty) {
        return;
      }
      if (dirty) {
        this.setApplicationDirty(dirty);
      }
    }
  },
  async mounted(this: any) {
    await this.loadModalData();
  }
});
